import { HelpAndOtherPolicyLayout } from "components/molecules";
import DriveLayout from "Layout/DriveLayout";
import React, { lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import LazyLoading from "components/fallbackUI/LazyLoading";
import ScrollToTop from "utils/ScrollToTop";

//Auth Pages
const MaintenancePage = lazy(() => import("pages/Auth/MaintenancePage"));
// const Login = lazy(() => import("pages/Auth/Login"));

const RecentPage = lazy(() => import("pages/DrivePages/RecentPage"));
const HomePage = lazy(() => import("pages/DrivePages/HomePage"));
const StarPage = lazy(() => import("pages/DrivePages/StarPage"));
const LockedPage = lazy(() => import("pages/DrivePages/LockedPage"));
const SearchPage = lazy(() => import("pages/DrivePages/SearchPage"));
const MyDrivePage = lazy(() => import("pages/DrivePages/MyDrivePage"));
const SharedWithMePage = lazy(
  () => import("pages/DrivePages/SharedWithMePage"),
);
const TrashPage = lazy(() => import("pages/DrivePages/TrashPage"));

// Settinngs Pages
const GeneralPage = lazy(() => import("pages/SettingPages/GeneralPage"));
const NotificationPage = lazy(
  () => import("pages/SettingPages/NotificationPage"),
);
const StoragePage = lazy(() => import("pages/SettingPages/StoragePage"));
const EditProfilePage = lazy(
  () => import("pages/SettingPages/EditProfilePage"),
);

//Folder page

const FolderPage = lazy(() => import("pages/FolderPage"));
const FilePreviewPage = lazy(() => import("pages/FilePreviewPage"));

const PublicFolderPage = lazy(() => import("pages/PublicFolderPage"));

const PublicImagePreviewPage = lazy(() => import("pages/PublicImagePreview"));

const basePath = "";
const generatePath = (slug) => {
  return `${basePath}/${slug}`;
};

const driveRoutes = [
  {
    path: generatePath("home"),
    element: <HomePage />,
  },
  {
    path: generatePath("starred"),
    element: <StarPage />,
  },
  {
    path: generatePath("recent"),
    element: <RecentPage />,
  },
  {
    path: generatePath("mydrive"),
    element: <MyDrivePage />,
  },
  {
    path: generatePath("locked"),
    element: <LockedPage />,
  },
  {
    path: generatePath("sharedwithme"),
    element: <SharedWithMePage />,
  },
  {
    path: generatePath("trash"),
    element: <TrashPage />,
  },
  {
    path: generatePath("settings/general"),
    element: <GeneralPage />,
  },
  {
    path: generatePath("settings/notification"),
    element: <NotificationPage />,
  },
  {
    path: generatePath("settings/editProfile"),
    element: <EditProfilePage />,
  },
  {
    path: generatePath("folder/:folderId"),
    element: <FolderPage />,
  },
  {
    path: generatePath("search"),
    element: <SearchPage />,
  },
  {
    path: generatePath("settings/storage-page"),
    element: <StoragePage />,
  },
];

const helpRoutes = [
  {
    path: "server-maintenance",
    element: <MaintenancePage />,
  },
];

const shareLinkRoutes = [
  {
    path: "shareLink/:fileId",
    element: <FilePreviewPage />,
  },
  {
    path: "shareLink/:folderId",
    element: <FilePreviewPage />,
  },
  {
    path: "sharelink/public/:folderId",
    element: <PublicFolderPage />,
  },
  {
    path: "sharelink/public/file",
    element: <PublicImagePreviewPage />,
  },
];

// const ExternalRedirect = () => {
//   window.location.replace("https://dev-drive.bigfootmail.com");
//   return null;
// };

const DriveNavigation = () => {
  return (
    <>
      <ScrollToTop />
      {/* Covers routes rendered outside DriveLayout (share links, policy
          pages). Drive routes are handled by the boundary inside DriveLayout. */}
      <Suspense fallback={<LazyLoading />}>
        <Routes>
          {shareLinkRoutes.map((route, index) => (
            <Route
              key={`${route.path}-${index}`}
              path={route.path}
              element={route.element}
            />
          ))}

          <Route element={<DriveLayout />}>
            {driveRoutes.map((route, index) => (
              <Route
                key={`${route.path}-${index}`}
                path={route.path}
                element={route.element}
              />
            ))}
          </Route>
          <Route element={<HelpAndOtherPolicyLayout />}>
            {helpRoutes?.map((route, index) => {
              return (
                <Route
                  key={`${route.path}-${index}`}
                  path={route.path}
                  element={route.element}
                />
              );
            })}
          </Route>
          <Route path="*" element={<Navigate to="/drive/home" />} />
        </Routes>
      </Suspense>
    </>
  );
};

export default DriveNavigation;
